import React from 'react';
import { PropTypes } from 'prop-types';
import { Checkbox, Collapse } from 'antd';
import { strings } from '../src/constants/localization';

const { Panel } = Collapse;

class SidebarHeading extends React.Component {

  handleOnCheckChange = (e, keyPath) => {
    if (keyPath) {
      this.props.onCheckChange(e, `${this.props.heading.key}.${keyPath}`, this.props.locationKey);
    } else {
      this.props.onCheckChange(e, this.props.heading.key, this.props.locationKey);
    }
  }

  render() {
    const layers = this.props.heading.layers.map(layer => {
      return (
        <Checkbox key={ layer.key }
          checked={ layer.isChecked }
          disabled={ this.props.isLoading }
          onChange={e => this.handleOnCheckChange(e, `${layer.key}`)}>
          { strings[layer.label] }
          <span className="map-legend" style={{backgroundColor: layer.style.color}}></span>
        </Checkbox>
      )
    });

    const headings = this.props.heading.headings.map(heading => {
      const checkChange = (e, keyPath) => {
        this.handleOnCheckChange(e, keyPath, this.props.locationKey)
      }

      return (
        <SidebarHeading key={ heading.key }
          isLoading={ this.props.isLoading } 
          heading={ heading }
          locationKey={ this.props.locationKey }
          onCheckChange={ checkChange } />
      )
    });

    const selectAllCheckbox = (heading) => {
      return (
        <Checkbox key={ heading.key }
          checked={ heading.isChecked }
          disabled={ this.props.isLoading }
          onChange={e => this.handleOnCheckChange(e, null)}
          onClick={e => e.stopPropagation()}>
          { strings.all }
        </Checkbox>
      )
    }

    return (
      <Collapse>
        <Panel className="leaf" 
          header={strings[this.props.heading.label]} 
          key={this.props.heading.key}
          extra={ selectAllCheckbox(this.props.heading) }>
          { layers }
          { headings }
        </Panel>
      </Collapse>
    );
  }
}

SidebarHeading.propTypes = {
  heading: PropTypes.object.isRequired,
  locationKey: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  onCheckChange: PropTypes.func.isRequired,
};

export default SidebarHeading;